import React from "react"
import ReactDOM from "react-dom"
import { applyMiddleware, createStore } from "redux"
import { Provider } from "react-redux"

// MIDDLEWARE'S
import promise from "redux-promise"
import multi from "redux-multi"
import thunk from "redux-thunk"

import rootReducer from "./reducers"
import AuthOrApp from "./AuthOrApp"


const store = applyMiddleware(promise, multi, thunk)(createStore)(rootReducer)

ReactDOM.render(
    <Provider store={store}>
        <AuthOrApp />
    </Provider>,
    document.getElementById("root")
)